import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full max-h-[400px]" }
const _hoisted_2 = ["onDragenter", "onDragleave"]
const _hoisted_3 = { class: "flex flex-col items-center justify-center gap-3 pt-5 pb-6 object-cover" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-sm" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Click para subir archivo"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" o arrastra el fichero aquí. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "JPG, JPEG, PNG", -1)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputImage',
  emits: ["uploadFile"],
  setup(__props, { emit }) {



const activeDropzone = ref<boolean>(false);
const selectedFile = ref<any>(null);

function switcActivationDropzone() {
  activeDropzone.value = !activeDropzone.value;
}

function inputFileHandler(event: Event | DragEvent, isDrag = false) {
  let target: HTMLInputElement | DragEvent;
  let file: File | undefined;
  if (isDrag) {
    activeDropzone.value = false;
    target = event as DragEvent;
    file = target.dataTransfer ? target.dataTransfer?.files[0] : undefined;
  } else {
    target = event.target as HTMLInputElement;
    file = target.files ? target.files[0] : undefined;
  }
  if (file == undefined) {
    return false;
  }
  const reader = new FileReader();

  reader.onload = () => (selectedFile.value = reader.result);

  reader.readAsDataURL(file);
  emit("uploadFile", file);

  // restringir si ya tiene un contrato firmado ??
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: "dropzone-file",
      onDragenter: _withModifiers(switcActivationDropzone, ["prevent"]),
      onDragleave: _withModifiers(switcActivationDropzone, ["prevent"]),
      onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[2] || (_cache[2] = _withModifiers((event)=>inputFileHandler(event, true), ["prevent"])),
      class: _normalizeClass([{ 'bg-button-green/80 text-white': activeDropzone.value }, "flex flex-col items-center hover:bg-button-green/80 transition-all hover:text-white justify-center w-full max-h-[300px] border-2 border-dashed rounded-lg cursor-pointer dark:border-gray-600"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        (selectedFile.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "max-h-[300px] pt-1",
              src: selectedFile.value
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_mdicon, {
                name: "file-document-multiple",
                size: "45"
              }),
              _hoisted_5,
              _hoisted_6
            ], 64))
      ]),
      _createElementVNode("input", {
        id: "dropzone-file",
        type: "file",
        class: "hidden",
        accept: ".png,.jpg,.jpeg",
        onChange: _cache[0] || (_cache[0] = (event)=>inputFileHandler(event))
      }, null, 32)
    ], 42, _hoisted_2)
  ]))
}
}

})